<h2 mat-dialog-title>
  <button class="m-0">Renew Subscription</button>
  <button mat-dialog-close [disabled]="isSubProcessing">
    <span class="material-symbols-outlined">close</span>
  </button>
</h2>
<mat-dialog-content class="mat-typography add_company_popup">
  <app-add-product-v2 [companyId]="companyId" [offer]="offer" [isEdit]="true"
    (onCompanySubAdd)="onCompanySubAdd($event)" (inProgress)="subInProgress($event)"></app-add-product-v2>
</mat-dialog-content>